module.exports = __webpack_public_path__ + "static/scale-model-of-bahia-travel-&-multiservices-in-bakersfield-california-6eb92ff6a00fe8d2949ef3e96516168e.png";